import { RestClient } from './RestClient'
import store from 'src/store'

export class TimeEntriesClient extends RestClient {
  /**
   * TimeEntries constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/time-entries`
  }

  /**
   * Get a list of all time entries for the current company
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified time entries
   *
   * @param {(...number|number[])} id - time entries to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Create a new time entry
   *
   * @param {Object} data - Time entry info
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Update an existing time entry
   *
   * @param {number} timeEntryId - Time entry id
   * @param {Object} data   - Time entry info
   *
   * @returns {AxiosPromise}
   */
  update (timeEntryId, data) {
    return this.call('patch', `${this.baseUrl}/${timeEntryId}`, data)
  }

  /**
   * Delete the specified time entries
   *
   * @param {(...number|number[])} timeEntryId - Time entries which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...timeEntryId) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(timeEntryId)}`)
  }

  /**
   * Search for time entries
   *
   * @param query
   * @returns {AxiosPromise}
   */
  search (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/search`)
  }

  /**
   * Suggest time entries
   *
   * @param query
   * @returns {AxiosPromise}
   */
  suggest (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/suggest`)
  }

  /**
   * Get the active time entry of the current user
   *
   * @returns {AxiosPromise}
   */
  active () {
    return this.call('get', `${this.baseUrl}/active`)
  }

  /**
   * Settle the specified time entries
   *
   * @param {number[]} timeEntries
   * @param {number} invoiceId
   * @returns {AxiosPromise}
   */
  settle (timeEntries, invoiceId = undefined) {
    return this.call('post', `${this.baseUrl}/settle`, {
      time_entries: timeEntries,
      invoice_id: invoiceId
    })
  }

  /**
   * Create a time report.
   *
   * @param filters
   * @returns {AxiosPromise}
   */
  export (filters = {}) {
    return this.call('post', `${this.baseUrl}/export`, Object.assign({ format: 'PDF' }, filters), {
      'Accept': 'application/pdf'
    }, {
      responseType: 'arraybuffer'
    })
  }
}
